<template>
  <div>
    <v-row>
      <v-col md="2">
        <ModuleHeader>Monedero</ModuleHeader>
      </v-col>
      <v-col md="10" class="text-right">
        <v-btn color="green" dark @click="exportExcel"
          ><v-icon>mdi-file-excel-box</v-icon> Exportar a Excel
          <!-- <download-excel
            class="exportExcel"
            type="xls"
            name="Monederos.xls"
            :data="excelData"
          >
            Exportar a Excel
          </download-excel> -->
        </v-btn>
      </v-col>
    </v-row>
    <uv-data-table
      :config="config"
      :data="monederos"
      :pageRows="15"
      @buttonClick="dtButtonClick"
      @buttonOptClick="optButtonClick"
    ></uv-data-table>
    <modal v-model="showModal" :showFooter="false" title="Movimientos monedero">
      <formMonedero
        :edit="editMode"
        :key="formIndex"
        @toggle="toggleModal"
        :dataEdit="editData"
        @successData="successData"
      >
      </formMonedero>
    </modal>
    <modal v-model="showURL" :showFooter="false" title="URL Agencias">
      <v-alert outlined color="green">
        <div class="text-h6">
          Url generado para consulta de movimientos a monedero de
          <b>{{ editData.NombreCompleto }}</b>
        </div>
        <div>
          {{ urlBase }}/balanceMonedero/{{
            $store.getters.getFirebaseApp.tenant
          }}/{{ editData.Id }}
        </div>
        <v-btn @click="copy()" color="green" dark>Copiar al portapapeles</v-btn>
      </v-alert>
    </modal>
  </div>
</template>

<style></style>

<script>
import modal from "../../MainComponents/modal.vue";
import uvDataTable from "../../MainComponents/DataTable.vue";
import formMonedero from "../Monedero/FormMonedero.vue";
import Cliente from "../../../clases/Cliente.js";
import Currencies from "../../../clases/Currencies.js";
import GenericExcelExporter from "../../../clases/ExcelMaker/GeneralExcel.js";
export default {
  name: "MonederoCRUD",
  components: {
    modal,
    uvDataTable,
    formMonedero,
  },
  props: [],
  data() {
    return {
      showURL: false,
      urlBase: "admin.pargolfsolutions.com",
      //data_clientes:[],
      MainDepartamento: "",
      self: this,
      showModal: false,
      formKey: 0,
      formIndex: 0,
      editMode: false,
      Categories: [],
      editData: [],
      products: [],
      hoteles: [],
      usuarios: [],
      editedHotel: {},
      config: {
        selectableRow: true,
        selectConfig: {
          idRowData: "Id", // id necesario para indicar id unico del row que esta seleccionado y retornarlo en los eventos requeridos
        },
        orderByCol: { Field: "", Type: "Asc" },
        buttons: [
          {
            text: "Movimientos Monedero",
            icon: "lni lni-pencil-alt",
            buttonId: "movimientosMonedero",
            require: true,
          },
          {
            text: "URL Consulta Movimientos",
            icon: "lni lni-link",
            buttonId: "webUrl",
            require: true,
          },
        ],
        fields: [
          {
            title: "Apellidos",
            dataName: "Apellidos",
            text: "Nombre",
            value: "NombreCompleto",
          },

          {
            title: "Total Monedero",
            dataName: "Monedero",
            text: "Total Monedero",
            value: "SaldoMonedero",
            format: (row) => {
              let text = row["Monedero"]
                ? this.$pgsHelper.formatNumber(row["Monedero"].Saldo) + " P"
                : "Sin monedero";
              return text;
            },
          },

          {
            title: "Total ",
            dataName: "Monedero",
            text: "Total ",
            value: "SaldoMonedero",
            format: (row) => {
              let text = row["Monedero"]
                ? this.$pgsHelper.formatNumber(row["SaldoConversion"]) +
                  " " +
                  this.$Currencies.getCurrencyDefault()
                : "Sin monedero";
              return text;
            },
          },
        ],
      },
    };
  },
  methods: {
    exportExcel() {
      GenericExcelExporter.generateExcelBuffer(this.excelData)
        .then((buffer) => {
          const blob = new Blob([buffer], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          });
          const url = window.URL.createObjectURL(blob);
          const link = document.createElement("a");
          link.href = url;
          link.download = "Monedero.xlsx";
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          window.URL.revokeObjectURL(url);
        })
        .catch((error) => console.error("Error exportando:", error));
    },
    copy() {
      let url =
        this.urlBase +
        "/balanceMonedero/" +
        this.$store.getters.getFirebaseApp.tenant +
        "/" +
        this.editData.Id;

      navigator.clipboard.writeText(url).then(
        () => {
          this.$toast.success(" ", "Copiado al portapapeles");
        },
        function () {
          this.$toast.error(" ", "Error copiando");
        }
      );
    },
    dtButtonClick(buttonId, idSelected) {
      if (buttonId == "movimientosMonedero") {
        this.formIndex++;
        this.editMode = true;
        let prodEdit = this.$pgsHelper.getById(
          this.monederos,
          "Id",
          idSelected[0]
        );
        this.editData = prodEdit;
        this.showModal = true;
      }
      if (buttonId == "webUrl") {
        let prodEdit = this.$pgsHelper.getById(
          this.monederos,
          "Id",
          idSelected[0]
        );
        this.editData = prodEdit;
        this.showURL = true;
      }
      if (buttonId == "deleteCupon") {
        this.deleteCupon(idSelected[0]);
      }
    },
    optButtonClick(buttonId, ref) {},

    successData(data) {
      this.$pgsHelper.log(data);
      let sendData = {
        FechaCreacion: Date.now(),
        Mayoristas: {},
        Departamentos: {},
        Moneda: "USD",
        Precio: parseFloat(data.costoCupon),
        Nombre: data.nombre,
        Tipo: "Cupon",
        Activo: data.status,
        UsosVenta: data.cuponesIlimitados ? null : data.cantidad,
      };
      /*let catalogo = [];
        data.productos.forEach(element => {
            catalogo.push({
                    Id: element.id,
                    CantVenta: element.CantidadCupon,
                    MndaContable: "USD",
                    MndaMayorista: "USD",
                    Tipo:element.Tipo,
                    Origen: element.Origen,
                    PrcoContable: element.PrecioContable,
                    PrcoMayorista: element.PrecioMayorista,
                    }
            );  
        });*/
      sendData.Catalogo = data.productos;
      sendData.Mayoristas[data.mayorista] = true;
      sendData.Departamentos[this.MainDepartamento] = true;

      this.$pgsHelper.log(sendData);
      if (data.Id == "" || !data.Id) {
        this.createCupon(sendData);
      } else {
        sendData.Id = data.Id;
        this.editCupon(sendData);
      }
    },
    createCupon(datos) {
      this.$swal({
        title: "¿Deseas agregar este cupón?",
        text: "Podras editarlo cuando quieras",
        icon: "warning",
        allowOutsideClick: false,
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Agregar",
        showLoaderOnConfirm: true,
        preConfirm: async () => {
          return await this.$store.getters.getFirebaseApp.fba
            .call("RVA-Cupones-crearCuponMayorista", datos)
            .then(function (result) {
              return result;
            })
            .catch((error) => {
              this.$swal.showValidationMessage(`Request failed: ${error}`);
            });
        },
      }).then((result) => {
        if (result.value) {
          // this.$emit('reloadClient');
          if (result.value.data.ok) {
            const targetId = (result.value.data && (result.value.data.id || (result.value.data.data && result.value.data.data.id))) || datos.Id || datos.id;
            this.$pgsHelper.writeLog({
              Evento: "CUPON_CREATE",
              Mensaje: "Cupón mayorista creado",
              reference: { id: targetId, tp: "RVA-Cupon", al: "CUPON MAYORISTA" },
              data: datos
            });
            this.$swal({
              title: "Guardado",
              text: "El cupón se guardo correctamente",
              icon: "success",
            }).then(() => {
              this.toggleModal(false);
              this.getCupons();
            });
          } else {
            this.$swal(
              "Error guardando Datos",
              result.value.data.error,
              "error"
            );
          }
        }
      });
    },
    deleteCupon(id) {
      const deletedObject = this.$pgsHelper.getById(this.monederos, "Id", id) || { Id: id, Departamento: this.MainDepartamento };
      let datos = { Id: id, Departamento: this.MainDepartamento };
      this.$swal({
        title: "¿Deseas eliminar este cupón?",
        text: "Se eliminara permanentemente",
        icon: "warning",
        allowOutsideClick: false,
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Eliminar",
        showLoaderOnConfirm: true,
        preConfirm: async () => {
          return await this.$store.getters.getFirebaseApp.fba
            .call("RVA-Cupones-eliminarCuponMayorista", datos)
            .then(function (result) {
              return result;
            })
            .catch((error) => {
              this.$swal.showValidationMessage(`Request failed: ${error}`);
            });
        },
      }).then((result) => {
        if (result.value) {
          if (result.value.data.ok) {
            this.$pgsHelper.writeLog({
              Evento: "CUPON_DELETE",
              Mensaje: "Cupón mayorista eliminado",
              reference: { id: id, tp: "RVA-Cupon", al: "CUPON MAYORISTA" },
              data: deletedObject
            });
            this.$swal(
              "El cupón se elimino correctamente",
              "El cupón se elimino correctamente",
              "success"
            );
            this.getCupons();
          } else {
            this.$swal(
              "Error eliminando datos",
              result.value.data.error,
              "error"
            );
          }
        }
      });
    },

    editCupon(datos) {
      this.$swal({
        title: "¿Deseas editar el cupón?",
        text: "",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        allowOutsideClick: false,
        confirmButtonText: "Editar",
        showLoaderOnConfirm: true,
        preConfirm: async () => {
          return await this.$store.getters.getFirebaseApp.fba
            .call("RVA-Cupones-editarCuponMayorista", datos)
            .then(function (result) {
              return result;
            })
            .catch((error) => {
              this.$swal.showValidationMessage(`Request failed: ${error}`);
            });
        },
      }).then((result) => {
        if (result.value) {
          if (result.value.data.ok) {
            this.$pgsHelper.writeLog({
              Evento: "CUPON_EDIT",
              Mensaje: "Cupón mayorista editado",
              reference: { id: datos.Id || datos.id, tp: "RVA-Cupon", al: "CUPON MAYORISTA" },
              data: datos
            });
            this.$swal({
              title: "Guardado",
              text: "El cupón se guardo correctamente",
              icon: "success",
            }).then(() => {
              this.toggleModal(false);
              this.getCupons();
            });
          } else {
            this.$swal(
              "Error guardando información",
              result.value.data.error,
              "error"
            );
          }
        }
      });
    },

    toggleModal(open) {
      this.showModal = open;
    },

    getCuponById(code) {
      let itemIndex = this.$_.findIndex(this.global_cupon, { id: code });
      if (itemIndex >= 0) {
        return this.global_cupon[itemIndex];
      }

      return false;
    },
  },
  computed: {
    excelData() {
      let monederos = [];
      this.monederos.forEach((mone) => {
        monederos.push({
          Nombres: mone.Nombres,
          Apellidos: mone.Apellidos,
          Saldo: mone.Monedero ? mone.Monedero.Saldo : "Sin monedero",
        });
      });
      return monederos;
    },
    global_cupon() {
      let cup_prod = [
        {
          CantidadCupon: 1,
          Nombre: "Guante de Golf para Hombre-CC93",
          PrecioContable: 22,
          PrecioMayorista: 20,
          Origen: "-MLtKZvkWu8Ew6t9piKl",
          compId: "BHyZIJjGXIRlxsTVnJo0_-MLtKZvkWu8Ew6t9piKl",
          id: "BHyZIJjGXIRlxsTVnJo0",
        },
      ];
      let cupon = [
        {
          id: "papanoel",
          Nombre: "BDAY2020",
          Mayorista: "BestDay",
          Ilimitado: true,
          Cantidad: 2,
          CostoCupon: 1244,
          PrecioVenta: 1000,
          Productos: cup_prod,
          Estatus: true,
        },
        {
          id: "navidad",
          Nombre: "MAJESTIC2020",
          Mayorista: "Majestic Hotel",
          Ilimitado: false,
          Cantidad: 2,
          CostoCupon: 1244,
          PrecioVenta: 2000,
          Productos: cup_prod,
          Estatus: false,
        },
      ];

      //let sortReservations = this.$_.orderBy(prod,'Orden','asc');

      return cupon;
    },
    data_clientes() {
      let clientes = [];
      let rowclientes = Cliente.getClientsList();
      rowclientes.forEach((cliente) => {
        cliente.SaldoConversion = cliente.Monedero ? cliente.Monedero.Saldo : 0;
        cliente.SaldoConversion = cliente.SaldoConversion * 1;
        cliente.NombreCompleto = cliente.Nombres + " " + cliente.Apellidos;
        clientes.push(cliente);
      });

      return clientes;
    },
    monederos() {
      let monederos = [];
      this.data_clientes.forEach((element) => {
        if (element.id != "PUBLICOGENERAL") {
          element.SaldoMonedero = element.Monedero.Saldo;
          monederos.push(element);
        }
      });
      return monederos;
    },
  },
  watch: {},
  mounted() {
    // this.getClientes();
  },
  created() {
    this.MainDepartamento = localStorage.getItem("selectedDepartment");
  },
};
</script>
